import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ArchivePatient from './ArchivePatient';

interface Props extends BaseModalProps {
	patientId: string;
	workplaceId: string;
	onSuccess: () => void;
}

const ArchivePatientModal: React.FC<Props> = props => (
	<BaseModal title='component.archivePatient.modalTitle' {...props}>
		<ArchivePatient
			patientId={props.patientId}
			workplaceId={props.workplaceId}
			onSuccess={props.onSuccess}
		/>
	</BaseModal>
);

export default ArchivePatientModal;
